import getExtensionSettings from './extension-settings';
import getExtension from './extension';
import getExtensionVersionId from './extension-version-id';
import getExtensions from './extensions';
import getExtensionConfiguration from './extension-configuration';
import getExtensionConfigurations from './extension-configurations';
import getMainSource from './main-source';

export default {
  getExtensionSettings,
  getExtension,
  getExtensionVersionId,
  getExtensions,
  getExtensionConfiguration,
  getExtensionConfigurations,
  getMainSource,
};
